import Accordion from "react-bootstrap/Accordion";
import "bootstrap/dist/css/bootstrap.min.css";
import { palette } from "../../config";
import { MyNoiseGradadientBackground } from "../../components/backgrounds";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const FAQSection = () => {
  const { t, ready, i18n } = useTranslation();
  
  // Debug: Log translation status
  console.log('FAQSection - i18n ready:', ready, 'language:', i18n.language);
  console.log('FAQSection - faq title:', t('faq:title'));
  console.log('FAQSection - faq items:', t('faq:items', { returnObjects: true }));
  
  // Fallback FAQs if translation is not ready - memoized to prevent re-creation
  const fallbackFaqs = useMemo(() => [
    {
      question: "Che tipo di aziende può beneficiare dell'IA?",
      answer: "L'intelligenza artificiale non è più un'esclusiva delle grandi multinazionali..."
    }
  ], []);
  
  const faqs = useMemo(() => {
    console.log('FAQSection - faqs useMemo triggered, ready:', ready, 'language:', i18n.language);
    // Always try to get translations for current language, fallback to Italian only if translation is missing
    const translatedFaqs = t('faq:items', { returnObjects: true }) as Array<{question: string, answer: string}>;
    console.log('FAQSection - translatedFaqs:', translatedFaqs);
    
    if (Array.isArray(translatedFaqs) && translatedFaqs.length > 0) {
      return translatedFaqs;
    }
    
    // Fallback to Italian if translation is missing
    return fallbackFaqs;
  }, [t, i18n.language, fallbackFaqs]);

  return (
    <div className="faq__section section-container" key={`faq-${i18n.language}`}>
      <h1 className="section-title" style={{ paddingTop: "7rem" }}>
        {t('faq:title')}
      </h1>

      <div className="faq-container">
        <Accordion className="mt-5">
          {faqs.map((faq, index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
              style={{
                backgroundColor: palette.backgroundLightBright,
                border: "none",
              }}
            >
              <Accordion.Header>{faq.question}</Accordion.Header>
              <Accordion.Body className="text-white">{faq.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};


